import { EVENT_ALLOWLIST } from '../constants';
import type { EventName } from '../types';
import { api } from './api';

export function track(
  eventName: EventName,
  properties: Record<string, string> = {},
  taskId?: string
) {
  if (!EVENT_ALLOWLIST.has(eventName)) return;
  const safeProperties = Object.fromEntries(
    Object.entries(properties).filter(
      ([key, value]) =>
        !/(body|content|phone|mobile|code|token|cookie|raw|session|password)/i.test(key) &&
        value.length <= 256
    )
  );
  void api
    .post('/events', {
      event_name: eventName,
      task_id: taskId,
      event_id: crypto.randomUUID(),
      occurred_at: new Date().toISOString(),
      properties: safeProperties
    })
    .catch(() => undefined);
}
